import React from 'react';

const Footer = React.memo(() => {
  return (
    <footer className="mt-auto bg-white w-full">
      <nav className="flex justify-center items-center h-full bg-gray-800">
        <ul className="grid grid-cols-2 md:flex md:flex-row gap-4 md:gap-6 lg:gap-8 max-w-2xl md:max-w-none mx-auto p-4 md:justify-center">
          <li className="flex justify-center items-center">
            <a href="https://www.linkedin.com/in/josiah-stelzl-3122b4241/" target="_blank" rel="noopener noreferrer" className="text-white py-3 md:py-2 px-4 text-lg md:text-lg flex items-center">
              <svg className="h-8 w-8 md:h-6 md:w-6 inline-block" fill="white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <title>LinkedIn</title>
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
              <span className="ml-2 font-roboto font-bold text-base md:text-lg">
                LinkedIn
              </span>
            </a>
          </li>
          <li className="flex justify-center items-center">
            <a href="https://github.com/Jstelzl?tab=repositories" target="_blank" rel="noopener noreferrer" className="text-white py-3 md:py-2 px-4 text-lg md:text-lg flex items-center">
              <svg className="h-8 w-8 md:h-6 md:w-6" fill="none" stroke="white" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                <path d="M16,2.345c7.735,0,14,6.265,14,14-.002,6.015-3.839,11.359-9.537,13.282-.7,.14-.963-.298-.963-.665,0-.473,.018-1.978,.018-3.85,0-1.312-.437-2.152-.945-2.59,3.115-.35,6.388-1.54,6.388-6.912,0-1.54-.543-2.783-1.435-3.762,.14-.35,.63-1.785-.14-3.71,0,0-1.173-.385-3.85,1.435-1.12-.315-2.31-.472-3.5-.472s-2.38,.157-3.5,.472c-2.677-1.802-3.85-1.435-3.85-1.435-.77,1.925-.28,3.36-.14,3.71-.892,.98-1.435,2.24-1.435,3.762,0,5.355,3.255,6.563,6.37,6.913-.403,.35-.77,.963-.893,1.872-.805,.368-2.818,.963-4.077-1.155-.263-.42-1.05-1.452-2.152-1.435-1.173,.018-.472,.665,.017,.927,.595,.332,1.277,1.575,1.435,1.978,.28,.787,1.19,2.293,4.707,1.645,0,1.173,.018,2.275,.018,2.607,0,.368-.263,.787-.963,.665-5.719-1.904-9.576-7.255-9.573-13.283,0-7.735,6.265-14,14-14Z"></path>
              </svg>
              <span className="ml-2 font-roboto font-bold text-base md:text-lg">
                Github
              </span>
            </a>
          </li>
          <li className="flex justify-center items-center">
            <a href="mailto:josiah.stelzl@example.com" className="text-white py-3 md:py-2 px-4 text-lg md:text-lg flex items-center">
              <svg className="h-8 w-8 md:h-6 md:w-6" fill="none" stroke="white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22 6l-10 10-10-10" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span className="ml-2 font-roboto font-bold text-base md:text-lg">
                Email
              </span>
            </a>
          </li>
          <li className="flex justify-center items-center">
            <a href="https://stackoverflow.com/users/19291664/josiah" target="_blank" rel="noopener noreferrer" className="text-white py-3 md:py-2 px-4 text-lg md:text-lg flex items-center">
              <svg className="h-8 w-8 md:h-6 md:w-6" fill="none" stroke="white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <title>Stack Overflow</title>
                <path d="M15.725 0l-1.72 1.277 6.39 8.588 1.716-1.277L15.725 0zm-3.94 3.418l-1.369 1.644 8.225 6.85 1.369-1.644-8.225-6.85zm-3.15 4.465l-.905 1.94 9.702 4.517.904-1.94-9.701-4.517zm-1.85 4.86l-.44 2.093 10.473 2.201.44-2.092-10.473-2.203zM1.89 15.47V24h19.19v-8.53h-2.133v6.397H4.021v-6.396H1.89zm4.265 2.133v2.13h10.66v-2.13H6.154Z" />
              </svg>
              <span className="ml-2 font-roboto font-bold text-base md:text-lg truncate">
                Stack Overflow
              </span>
            </a>
          </li>
        </ul>
      </nav>
    </footer>
  );
});

Footer.displayName = 'Footer';

export default Footer;